import { useEffect, useState } from "react";
import { LOGO } from "@/components/BrandLogo";
import { BRAND } from "@/lib/brand";

const KEY = "ela_intro_seen";

function shouldShow() {
  if (typeof window === "undefined") return false;
  if (window.location.hash?.includes("session_id=")) return false;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return false;
  try {
    return !sessionStorage.getItem(KEY);
  } catch {
    return false;
  }
}

export default function IntroReveal() {
  const [phase, setPhase] = useState(() => (shouldShow() ? "in" : "done"));

  useEffect(() => {
    if (phase === "done") return;
    try { sessionStorage.setItem(KEY, "1"); } catch {}
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setPhase("out"), 1900);
    const t2 = setTimeout(() => {
      document.body.style.overflow = "";
      setPhase("done");
    }, 2650);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, [phase]);

  if (phase === "done") return null;

  return (
    <div
      data-testid="intro-reveal"
      aria-hidden="true"
      className={`intro fixed inset-0 z-[100] bg-forest text-ivory flex flex-col items-center justify-center grain ${phase === "out" ? "intro-out" : ""}`}
    >
      <img src={LOGO.markLight} alt="" className="intro-mark h-28 sm:h-36 w-auto" draggable={false} />
      <div className="intro-rule mt-10 h-px w-24 bg-champagne" />
      <p className="intro-text mt-6 text-[11px] uppercase tracking-[0.34em] text-ivory/80">ELA Rituals</p>
      <p className="intro-text-2 mt-3 font-serif italic text-xl text-champagne">{BRAND.tagline}</p>
    </div>
  );
}
